export default {"src":"/_next/static/media/order_button_effect.9a654042.svg","height":72,"width":81,"blurWidth":0,"blurHeight":0};